export default "__VITE_ASSET__CAmmgpK7__"